export default __webpack_public_path__ + "static/media/Bot.70a816ba.png";